import * as React from 'react';
import { Clearfix } from './Clearfix';
import { Image } from './Image';
import { Nav, NavItem } from '../bootstrap-components/BootstrapComponents';
import SubNav from '../bootstrap-components/SubNav';
import { getLoggedInBruger, getBrugerDisplayName, canImpersonate } from '../../infrastructure/Security';
import { Bruger } from '../../models/Bruger';
import { BrugerRolleEnum } from '../../models/enums/BrugerRolleEnum';

export interface DropDownprops {
    toggleMenu: (e: any) => void;
}

export interface DropDownState {
    user: Bruger;
}

class DropDownMenu extends React.Component<DropDownprops, DropDownState> {
    constructor(props: DropDownprops) {
        super(props);

        this.clickAway = this.clickAway.bind(this);

        this.state = {
            user: new Bruger()
        };
    }

    componentDidMount() {
        // setTimeout(this.clickAway, 1000);

        this.clickAway();

        this.setState({
            user: getLoggedInBruger()
        });
    }

    clickAway() {
        $('#dropdown-menu').bind('clickoutside', () => {
            this.props.toggleMenu(undefined);
        });
    }

    getImpersonationMenuItem() {
        if (canImpersonate()) {
            return (
                <NavItem href='/log-ind-som' text='Log ind som' callback={this.props.toggleMenu} />
            );
        }

        return undefined;
    }    

    getUserMenuItems() {
        let displayName = getBrugerDisplayName();
        return (
            <SubNav id='user-menu' text={displayName} dataTarget='usermenu' iconToggleShow='plus' iconToggleHide='minus'>
                <NavItem href='/logout' text='Log ud' callback={this.props.toggleMenu} />
                <NavItem href='/bruger-profil' text='Profil' callback={this.props.toggleMenu} />
                {this.getImpersonationMenuItem()}
            </SubNav>
        );
    }

    renderMenu(rolle: BrugerRolleEnum) {
        let brugermenu = this.getUserMenuItems();
        if (rolle === BrugerRolleEnum.Elev) {
            return (
                <Nav>
                    <NavItem href='/' text='Skrivebord' callback={this.props.toggleMenu} />
                    <NavItem href='/' text='Konkurrenceresultater' callback={this.props.toggleMenu} />
                    {brugermenu}
                </Nav>
            );
        } else if (rolle === BrugerRolleEnum.Laerer || rolle === BrugerRolleEnum.Ekstern) {
            const konkurrencerSubnav = rolle === BrugerRolleEnum.Laerer ? (
                <SubNav text='Konkurrencer' dataTarget='konkurrencersubmenu' iconToggleShow='plus' iconToggleHide='minus'>
                    <NavItem href='/konkurrencer' text='Se tidligere konkurrencer' callback={this.props.toggleMenu} />
                    <NavItem href='/tilmelding' text='Tilmelding' callback={this.props.toggleMenu} />
                </SubNav>) : (
                    <SubNav text='Konkurrencer' dataTarget='konkurrencersubmenu' iconToggleShow='plus' iconToggleHide='minus'>
                        <NavItem href='/konkurrencer' text='Se tidligere konkurrencer' callback={this.props.toggleMenu} />
                    </SubNav>);

            return (
                <Nav>
                    <NavItem href='/' text='Skrivebord' callback={this.props.toggleMenu} />
                    {konkurrencerSubnav}
                    <NavItem href='/support' text='Support' callback={this.props.toggleMenu} />
                    {brugermenu}
                </Nav>
            );
        } else /* if (user.rolle === BrugerRolleEnum.Administrator) */ {
            return (
                <Nav>
                    <NavItem href='/' text='Skrivebord' callback={this.props.toggleMenu} />
                    <NavItem href='/konkurrencer' text='Konkurrencer' callback={this.props.toggleMenu} />
                    <NavItem href='/eksternadgang' text='Eksterne brugere' callback={this.props.toggleMenu} />
                    <SubNav text='Konkurrencemateriale' dataTarget='konkurrencematerialesubmenu' iconToggleShow='plus' iconToggleHide='minus'>
                        <NavItem href='/opgaver' text='Opgaver' callback={this.props.toggleMenu} />
                        <NavItem href='/opgavepakker' text='Opgavepakker' callback={this.props.toggleMenu} />
                        <NavItem href='/logboeger' text='Logbøger' callback={this.props.toggleMenu} />
                    </SubNav>
                    {brugermenu}
                </Nav>
            );
        }
    }

    render() {

        const aktivBruger = this.state.user as Bruger;

        return (
            <div id='dropdown-menu'>
                <div id='dropdown-menu-header'>
                    <div className='dropdown-menu-wrapper'>
                        <p>Menu</p>
                        <div className='image-wrapper' onClick={this.props.toggleMenu}>
                            <Image source='close_black.png' alt='close btn' />
                        </div>
                        <Clearfix />
                    </div>
                </div>
                <div id='dropdown-list-items'>
                    {this.renderMenu(aktivBruger.rolle)}
                </div>
            </div>
        );
    }
}

export default DropDownMenu;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/layout/DropDownMenu.tsx